module.exports = __webpack_public_path__ + "r-v3/img/color_off.4d953959.svg";